/**
 * Masthead Search Modal
 */

import delegate from 'delegate'

import { on, trigger } from './utils/events'
import * as tools from './utils/tools'

const el = {
	container: document.querySelector('body'),
	searchModal: document.querySelector('[data-js="search-modal"]'),
}

/**
 * Help function to disable all tabbable elements within a given container.
 *
 * @param containerEl
 */
const disableTabbable = (containerEl) => {
	const links = tools.getNodes('button', true, containerEl, true)
	links.forEach((link) => link.setAttribute('tabindex', '-1'))
}

/**
 * Helper method to enable all tabbable elements within a given container.
 *
 * @param containerEl
 */
const enableTabbable = (containerEl) => {
	const links = tools.getNodes('a, button', true, containerEl, true)
	links.forEach((link) => link.setAttribute('tabindex', ''))
}

/**
 * Update the ARIA attributes when closed
 *
 * @param triggerEl
 * @param containerEl
 */
const closeAriaAttributes = (triggerEl, containerEl) => {
	triggerEl.setAttribute('aria-expanded', 'false')
	containerEl.setAttribute('aria-hidden', 'true')

	if (triggerEl.getAttribute('data-label-hidden')) {
		triggerEl.setAttribute(
			'aria-label',
			triggerEl.getAttribute('data-label-hidden')
		)
	}
}

/**
 * Update the ARIA attributes when opened
 *
 * @param triggerEl
 * @param containerEl
 */
const openAriaAttributes = (triggerEl, containerEl) => {
	triggerEl.setAttribute('aria-expanded', 'true')
	containerEl.setAttribute('aria-hidden', 'false')

	if (triggerEl.getAttribute('data-label-shown')) {
		triggerEl.setAttribute(
			'aria-label',
			triggerEl.getAttribute('data-label-shown')
		)
	}
}

/**
 * Open search modal
 */
const openSearch = () => {
	// Trigger an event to inform other scripts of the change.
	trigger({ event: 'ur_core/search_active', native: false })

	// Display the site nav
	el.container.classList.add('masthead__search--is-active')

	// Handle additional tasks for displaying the nav.
	//disableTabbable(el.titleRow);
	//disableTabbable(el.siteNav);
	openAriaAttributes(el.siteSearchTrigger, el.searchModal)

	// Update the visual text label displayed on the nav trigger.
	// const visualLabel = el.siteSearchTrigger.querySelector( 'span' );
	// visualLabel.innerHTML = visualLabel.getAttribute( 'data-label-shown' );

	// Auto focus input. Must wait millisecond for element to appear.
	const input = document.querySelector('[data-js="search-query"]')
	setTimeout(function () {
		input.focus()
	}, 100)
}

/**
 * Close search modal
 */
const closeSearch = () => {
	// Close the site nav.
	el.container.classList.remove('masthead__search--is-active')

	// Handle additional tasks for displaying the nav.
	//enableTabbable(el.titleRow);
	//enableTabbable(el.SiteNav);
	closeAriaAttributes(el.siteSearchTrigger, el.searchModal)

	// Update the visual text label displayed on the nav trigger.
	// const visualLabel = el.siteSearchTrigger.querySelector( 'span' );
	// visualLabel.innerHTML = visualLabel.getAttribute( 'data-label-hidden' );

	// Reset the margin-top position
	el.searchModal.style.marginTop = '0'
}

/**
 * Toggle the site nav on mobile
 */
const toggleSearch = () => {
	el.container.classList.contains('masthead__search--is-active')
		? closeSearch()
		: openSearch()
}

/**
 * Handle closing the mobile nav or submenu based on which is active.
 */
const handleOutActions = () => {
	if (el.container.classList.contains('masthead__search--is-active')) {
		closeSearch()
		el.siteSearchTrigger.focus()
	}
}

/**
 * Handle clicking outside the masthead to close the site nav for mobile and a submenu on desktop.
 *
 * @param e
 */
const handleClickOut = (e) => {
	if (!el.container.classList.contains('masthead__search--is-active')) {
		return
	}

	if (!tools.closest(e.target, '[data-js="masthead"]')) {
		handleOutActions()
	}
}

/**
 * Handle the escape key to close the site nav on mobile and submenu on desktop.
 *
 * @param e
 */
const handleEsc = (e) => {
	// Bail if the key press was not escape or the nav is not active.
	if (
		e.which !== 27 ||
		!el.container.classList.contains('masthead__search--is-active')
	) {
		return
	}

	handleOutActions()
}

/**
 * Bind any even handlers this module utilizes.
 */
const bindEvents = () => {
	delegate(el.container, '[data-js="toggle-search"]', 'click', toggleSearch)

	on(document, 'keyup', handleEsc)
	on(document, 'ur_core/nav_active', closeSearch)
}

/**
 * Cache a number of elements we need for functionality.
 */
const cacheElements = () => {
	el.titleRow = el.container.querySelector('[data-js="title-row"]')
	el.siteNav = el.container.querySelector('[data-js="site-navigation"]')
	el.siteSearchTrigger = el.container.querySelector('[data-js="toggle-search"]')
}

jQuery(document).ready(function ($) {
	function findInsiders(elem) {
		var tabbable = elem.find('input, button').filter(':visible')
		var firstTabbable = tabbable.first()
		var lastTabbable = tabbable.last()
		/*set focus on first input*/
		firstTabbable.focus()

		/*redirect last tab to first input*/
		lastTabbable.on('keydown', function (e) {
			if (e.which === 9 && !e.shiftKey) {
				e.preventDefault()
				firstTabbable.focus()
			}
		})

		/*redirect first shift+tab to last input*/
		firstTabbable.on('keydown', function (e) {
			if (e.which === 9 && e.shiftKey) {
				e.preventDefault()
				lastTabbable.focus()
			}
		})
	}

	$('#toggle-search').click(function (e) {
		e.preventDefault()
		findInsiders($('#search-wrapper'))
	})
})

/**
 * Init this module.
 */
const init = () => {
	if (!el.container || !el.searchModal) {
		return
	}
	cacheElements()
	bindEvents()
}

init()

export default init
